define('app/views/dc_lasts_list_view',[
    'app/setup',
    'app/views/dc_lasts_item_view',
    'app/views/dc_verify_phone_number_view',
    'app/views/dc_deal_condition_modal_view',
    'app/views/dc_multi_use_modal_view'],

  function (takhfifan) {
    takhfifan.DiscountLastsListView = Backbone.View.extend({
      initialize: function (options) {
        var  _this = this;
        this.checkUrl = $('#tkh-check-customer-can-buy-url').val();
        this.$el.find('.tkh-latest-dc-item').each(function () {
          new takhfifan.DiscountLastsItemView({el: $(this) , checkUrl: _this.checkUrl});
        });

        new takhfifan.dcVrifyPhoneNumber({el: $('.tkh-dc-verification-modal')});
        new takhfifan.dcMultiUseModal({el: $('.dc-multi-use-modal-wrapper')});
        new takhfifan.dcDealConditionModal({el: $('.tkh-dc-deal-conditions-modal-wrapper')});
      },
    });
  });
